import {buildStateEvent, GenericStateEvent} from '../../common-redux'
import {PriorityLevel} from '../priority'

export interface UrgencyStateEvent<T> extends GenericStateEvent<T> {}

export const GetAllUrgencySuccessEvent = {
    type: 'GetAllUrgencySuccessEvent',
    build: (payload: PriorityLevel[]) => buildStateEvent(GetAllUrgencySuccessEvent.type, payload)
}
